import { ComponentProps } from 'react'
import { MultiChart } from './MultiChart'

// Common metadata fields that should not be plotted as data values
const METADATA_KEYS = ['date', 'timestamp']

export const extractKeysToPlot = (
    data: ComponentProps<typeof MultiChart>['data'],
    xKey: ComponentProps<typeof MultiChart>['xKey']
) => {
    if (!data.length) return []
    return Object.keys(data[0] ?? {}).filter(
        (key) => key !== xKey && !METADATA_KEYS.includes(key)
    )
}
